import React, { Component } from 'react'
import Titulo from '../comum/Titulo'
import { PERFIL_ADMIN, getAdminEmpresa, getGestorEmpresa } from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import EmissaoCteOS from './EmissaoCteOS';
import { withRouter } from 'react-router-dom';
import buscarEmissoesCteOS from '../../actions/cteos/buscarEmissoesCteOS';
import selecionarEmissaoCteOs from '../../actions/cteos/selecionarEmissaoCteOs';
import transmitirEmissaoCteOs from '../../actions/cteos/transmitirEmissaoCteOs';
import cancelarCteOs from '../../actions/cteos/cancelarCteOs';
import { showSuccessMsg } from '../../util/messagesUtil';
import CabecalhoRodapeTabela from '../comum/CabecalhoRodapeTabela';
import BotoesPaginacaoCteOs from './BotoesPaginacaoCteOs';
import PaginacaoCteOs from './PaginacaoCteOs';
import determinarPaginaAtual from '../../actions/cteos/determinarPaginaAtualCteOs'
import { alterouEmpresa } from '../../actions/empresa/alterarEmpresaSelecionada';
import { alterouFiltro, alterouPagina } from '../../util/filtros';
import PainelFiltragem from './PainelFiltrosCteOs';

const ModalConfirmacaoTransmissaoCteOs = ({transmitir, limpar}) => (
    <div className="modal fade" id="modalConfirmacaoTransmissaoCteOs" tabIndex="-1" role="dialog"
         aria-labelledby="modalConfirmacao" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content vx-modal-content">
                <div className="vx-modal-header">
                    <div className="vx-modal-header-left">
                        <i className="material-icons">send</i>
                        <span className="vx-modal-title">Transmitir CT-e OS</span>
                    </div>
                    <button type="button" className="vx-modal-close" data-dismiss="modal" onClick={() => limpar()}>
                        <i className="material-icons">close</i>
                    </button>
                </div>
                <div className="vx-modal-body">
                    <p style={{margin: 0}}>Deseja transmitir o CT-e OS selecionado?</p>
                </div>
                <div className="vx-modal-footer">
                    <button type="button" className="vx-btn-secondary" data-dismiss="modal"
                            onClick={() => limpar()}>Cancelar
                    </button>
                    <button type="button" className="vx-btn-primary" data-dismiss="modal"
                            onClick={() => transmitir()}>
                        <i className="material-icons">send</i>
                        Transmitir
                    </button>
                </div>
            </div>
        </div>
    </div>);

const ModalCancelamentoCteOs = ({cancelar, limpar}) => (
    <div className="modal fade" id="modalCancelamentoCteOs" tabIndex="-1" role="dialog"
         aria-labelledby="modalConfirmacao" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content vx-modal-content">
                <div className="vx-modal-header">
                    <div className="vx-modal-header-left">
                        <i className="material-icons">cancel</i>
                        <span className="vx-modal-title">Cancelar CT-e OS</span>
                    </div>
                    <button type="button" className="vx-modal-close" data-dismiss="modal" onClick={() => limpar()}>
                        <i className="material-icons">close</i>
                    </button>
                </div>
                <div className="vx-modal-body">
                    <p style={{margin: 0}}>Deseja cancelar o CT-e OS selecionado?</p>
                </div>
                <div className="vx-modal-footer">
                    <button type="button" className="vx-btn-secondary" data-dismiss="modal"
                            onClick={() => limpar()}>Não
                    </button>
                    <button type="button" className="vx-btn-primary" data-dismiss="modal"
                            onClick={() => cancelar()}>
                        <i className="material-icons">check</i>
                        Sim
                    </button>
                </div>
            </div>
        </div>
    </div>);


export const CabecalhoTabela = () => (
    <div className="vx-gp-table-header vx-gp-table-header--cteos d-none d-lg-grid">
        <div>ID</div>
        <div>Emissão</div>
        <div>Tomador</div>
        <div>Serviço</div>
        <div>Série</div>
        <div>Valor</div>
        <div>Status CT-e OS</div>
        <div>Cancelamento</div>
        <div>Ações</div>
    </div>
);

export class PainelGerenciarEmissaoCteOS extends Component {

    UNSAFE_componentWillMount() {
        this.props.determinarPaginaAtual(1)
    }

    componentDidMount() {
        this.props.selecionarEmissaoCteOs(null);
        this.buscarEmissoesCteOS();
    }

    componentDidUpdate(prevProps) {
        if (alterouEmpresa(this.props, prevProps)) {
            if (this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
                this.buscarEmissoesCteOS();
            }
        }
        if (alterouFiltro(this.props, prevProps) || alterouPagina(this.props, prevProps)) {
            this.buscarEmissoesCteOS();
        }
    }

    buscarEmissoesCteOS() {
        this.props.buscarEmissoesCteOS(this.props.empresaSelecionada.id, this.props.paginaAtual, this.props.registrosPorPagina, this.props.filtrosAdicionados);
    }

    limparSelecaoEmissaoCteOs() {
        this.props.selecionarEmissaoCteOs(null);
    }

    transmitirEmissaoCteOs() {
        this.props.transmitirEmissaoCteOs(this.props.emissaoCteOsSelecionado.id, this.props.empresaSelecionada.id)
            .then(() => {
                showSuccessMsg('Foi iniciado a transmissão do ct-e os!');
                this.buscarEmissoesCteOS();
            })
    }

    cancelarCteOs() {
        this.props.cancelarCteOs(this.props.emissaoCteOsSelecionado.id, this.props.empresaSelecionada.id)
            .then(() => {
                showSuccessMsg('Foi iniciado o cancelamento do ct-e os!');
                this.buscarEmissoesCteOS();
            })
    }
    exibirBotaoNovoCteOS() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getAdminEmpresa(this.props.empresaSelecionada.id)]}>
                <div className="vx-gp-toolbar">
                    <button className="vx-btn-primary"
                        onClick={() => this.props.history.push('/painel-cadastro-cte-os')}>
                        <span className="material-icons">add</span>
                        Nova CT-e OS
                    </button>
                </div>
            </Autorizacao>);
    }

    exibirEmissoesCteOS() {
        if (this.props.emissoesCteOs.length === 0) {
            return (
                <div className="vx-gp-empty">
                    <span className="material-icons vx-gp-empty-icon">receipt_long</span>
                    <p className="vx-gp-empty-text">Nenhuma emissão de CT-e OS encontrada.</p>
                </div>
            );
        }
        return this.props.emissoesCteOs.map(it =>
            <EmissaoCteOS key={`emissaoCteOs-${it.id}`} cteOS={it} />);
    }

    exibirTabelaEmissaoCteOS() {
        return (
            <div className="col-12 conteudo-internas">
                <CabecalhoRodapeTabela OpcoesPaginacao={PaginacaoCteOs}
                                       BotoesPaginacao={BotoesPaginacaoCteOs}
                                       emissoesCteOs={this.props.emissoesCteOs}
                                       empresaSelecionada={this.props.empresaSelecionada}>
                    {this.props.emissoesCteOs.length !== 0 && <CabecalhoTabela />}
                    <div>
                        {this.exibirEmissoesCteOS()}
                    </div>
                </CabecalhoRodapeTabela>
            </div>
        );
    }

    render() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getAdminEmpresa(this.props.empresaSelecionada.id)]}>
                <div>
                    <div className="col-md-12">
                        <Titulo texto="Gerenciar CT-e OS" urlRetorno="/menu-cteos" />
                    </div>
                    <div className="col-12 filtro-busca">
                        <PainelFiltragem/>
                    </div>
                    {this.exibirBotaoNovoCteOS()}
                    {this.exibirTabelaEmissaoCteOS()}
                </div>
                <ModalConfirmacaoTransmissaoCteOs transmitir={this.transmitirEmissaoCteOs.bind(this)} limpar={this.limparSelecaoEmissaoCteOs.bind(this)} />
                <ModalCancelamentoCteOs cancelar={this.cancelarCteOs.bind(this)} limpar={this.limparSelecaoEmissaoCteOs.bind(this)} />
            </Autorizacao>
        );
    }
}


export const mapStateToProps = state => ({
    empresaSelecionada: state.empresaSelecionada,
    emissoesCteOs: state.emissoesCteOs.emissaoCteOS,
    emissaoCteOsSelecionado: state.emissaoCteOsSelecionado,
    paginaAtual: state.paginaAtualCteOs,
    registrosPorPagina: state.registrosPorPaginalCteOs,
    filtrosAdicionados: state.filtrosAdicionadosCteOs
})

export default withRouter(connect(mapStateToProps,
    {
        buscarEmissoesCteOS,
        selecionarEmissaoCteOs,
        transmitirEmissaoCteOs,
        cancelarCteOs,
        determinarPaginaAtual
    })(reduxForm({
        form: 'formularioPainelCteOS'
    })(PainelGerenciarEmissaoCteOS)))